import { Component, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { AuthService } from '../../auth.service';
import { of } from 'rxjs';
import { delay } from 'rxjs/operators';
import { Router, ActivatedRoute } from '@angular/router';
import { LocalStorage } from 'src/app/core/localstorage';
import { UserService } from 'src/app/modules/user/user.service';
import { Title } from '@angular/platform-browser';
import { SetupService } from '@core/services/setup';

@Component({
    selector: 'app-change-password',
    templateUrl: './change-password.component.html',
    styleUrls: ['./change-password.component.scss'],
})
export class ChangePasswordComponent implements OnInit {
    /* Alerta de erro e sucesso */
    alert = {
        show: false,
        message: '',
        type: 'success',
    };

    form: any;

    changeFromEmail: boolean = false;

    get controls() {
        return this.form.controls;
    }

    constructor(
        private formBuilder: FormBuilder,
        private authService: AuthService,
        private router: Router,
        private route: ActivatedRoute,
        private userService: UserService,
        private title: Title,
        private setupService: SetupService
    ) {}

    ngOnInit(): void {
        this.formBuild();
        this.verifyTokenParameter();
        this.title.setTitle(`Trocar Senha - ${this.setupService.title}`);
    }

    formBuild() {
        this.form = this.formBuilder.group({
            currentPassword: ['', Validators.required],
            newPassword: ['', Validators.required],
            confirmNewPassword: ['', Validators.required],
        });
    }

    verifyTokenParameter() {
        const token = this.route.snapshot.queryParamMap.get('token');
        const hasToken = !!token;
        //console.log(this.route.snapshot);
        if (hasToken) {
            this.changeFromEmail = true;
            this.controls.currentPassword.clearValidators();
        }
    }

    requestPassword() {
        const player = this.route.snapshot.queryParamMap.get('player');
        this.authService.changePassword(this.form.value, player).subscribe(
            (returnSuccess) => this.successCallbackApi(returnSuccess),
            (returnFail) => this.errorCallbackServer(returnFail)
        );
    }

    /**
     * successCallbackApi: Retorna resultado da API
     * @param response
     */
    async successCallbackApi(response: any) {
        const success = response.status_code === 0;
        this.alert.message = response.description;
        this.alert.type = success ? 'success' : 'danger';
        this.alert.show = true;

        if (!success) {
            return this.errorCallbackServer(response);
        }

        this.form.reset();
        this.userService.saveUserToLocalStorage(response.registers?.registers?.usuario);
        this.authService.saveToken(response.token);

        await this.delay().toPromise();
        this.router.navigate(['/home']);
    }

    /**
     * errorCallbackServer: Retorna resultado de erros do servidor
     * @param fail
     */
    errorCallbackServer(fail: any) {
        // TODO:
        // - EXIBIR ALERTA ERRO
        // - LIMPAR CAMPO SENHA
        this.alert.type = 'danger';
        this.alert.message = fail.registers.message[0].message;
    }

    delay() {
        return of(1).pipe(delay(1000));
    }
}
